import { http } from '@/api/http'

// По ТЗ 03.09.2026 (4 раздел КПС «В расходе»):
// CRUD для интервалов отсутствия военнослужащего.
// Reason: 'leave' | 'business_trip' | 'hospital' | 'duty' | 'training' | 'other'.

export async function listAbsences(params = {}) {
  const { data } = await http.get('book/absences/', { params })
  return Array.isArray(data) ? data : (data?.results || [])
}

export async function listAbsencesOn(dateISO, extra = {}) {
  return listAbsences({ active_on: dateISO, ...extra })
}

export async function createAbsence(payload) {
  const { data } = await http.post('book/absences/', payload)
  return data
}

export async function updateAbsence(id, payload) {
  const { data } = await http.patch(`book/absences/${id}/`, payload)
  return data
}

export async function deleteAbsence(id) {
  await http.delete(`book/absences/${id}/`)
}

export const ABSENCE_REASONS = [
  { value: 'leave',         labelRu: 'Отпуск',          labelKk: 'Демалыс' },
  { value: 'business_trip', labelRu: 'Командировка',    labelKk: 'Іссапар' },
  { value: 'hospital',      labelRu: 'Госпиталь',       labelKk: 'Госпиталь' },
  { value: 'duty',          labelRu: 'Суточный наряд',  labelKk: 'Тәуліктік наряд' },
  { value: 'training',      labelRu: 'Учения',          labelKk: 'Жаттығулар' },
  { value: 'other',         labelRu: 'Другое',          labelKk: 'Басқа' },
]
